import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const StandardPage = ({ rendering }) => (
  <>
    <Placeholder name='page-head' rendering={rendering} />
    <Placeholder name='page-header' rendering={rendering} />
    <main>
      <Placeholder name='page-content' rendering={rendering} />
    </main>
    <Placeholder name='page-footer' rendering={rendering} />
  </>
);

export default StandardPage;
